import { addMonths } from 'date-fns';
import getNowDate from '@sdk/utils/getNowDate';
import { pgettext } from '@sdk/lang/gettext';
import type { DocumentData } from '@sdk/users/types/DocumentData';

export const getExampleItem = (currentUser): DocumentData => {
  return {
    id: -1,
    name: pgettext('example user document name', 'CPR certification'),
    mimetype: '',
    description: pgettext(
      'example user document description',
      'Official CPR certification from Red Cross'
    ),
    lastModifiedBy: currentUser,
    expirationDate: addMonths(getNowDate(), 1),
    isExpiringSoon: false,
    isExpired: false,
    user: currentUser,
    isShared: false,
    sharedVisibilityOption: '',
    expirationNotificationsEnabled: false,
  };
};
